import {SHOW_POPUP_WITH_SELECTBOX, HIDE_POPUP_WITH_SELECTBOX} from '@/store/mutation-types'

export default {
	computed: {
		hasPopupWithSelectbox() {
			return this.$store.getters.hasPopupWithSelectbox;
		},
		getPopupWithSelectboxMessage() {
			return this.$store.getters.getPopupWithSelectboxMessage;
		},
		getPopupWithSelectboxOptions() {
			return this.$store.getters.getPopupWithSelectboxOptions;
		},
		getPopupWithSelectboxButtonText() {
			return this.$store.getters.getPopupWithSelectboxSubmitButtonText;
		}
	},
	methods: {
		showPopupWithSelectbox(action, message, buttonText, options, data) {
			this.$store.commit(SHOW_POPUP_WITH_SELECTBOX, {action, message, buttonText, options, data})
		},
		hidePopupWithSelectbox() {
			this.$store.commit(HIDE_POPUP_WITH_SELECTBOX)
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/popup-with-selectbox.js